import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import Divider from '../Divider/Divider';
import Row from './Row';
import { elo as theme } from '../../themes';
import { jsx as ___EmotionJSX } from "@emotion/core";
var bodyStyles = /*#__PURE__*/css("display:table-cell;padding:0 ", theme.spacings.xxSmall, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var TableBody = function TableBody(_ref) {
  var data = _ref.data,
    headers = _ref.headers,
    position = _ref.position,
    ellipsis = _ref.ellipsis,
    maxLines = _ref.maxLines,
    dataTestId = _ref.dataTestId;
  return ___EmotionJSX("tbody", {
    css: bodyStyles
  }, data.map(function (row, index) {
    var shouldRenderDivider = index !== data.length - 1;
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
      key: row.id,
      row: row,
      index: index,
      headers: headers,
      position: position,
      ellipsis: ellipsis,
      maxLines: maxLines,
      dataTestId: dataTestId
    }), shouldRenderDivider && ___EmotionJSX(Divider, {
      light: true
    }));
  }));
};
var headerPropsTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  width: PropTypes.number
});
var cellPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  value: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.element
});
var menuPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func
});
TableBody.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    cells: PropTypes.arrayOf(cellPropTypes).isRequired,
    menu: PropTypes.arrayOf(menuPropTypes)
  }).isRequired).isRequired,
  headers: PropTypes.arrayOf(headerPropsTypes),
  position: PropTypes.oneOf(['left', 'right']),
  ellipsis: PropTypes.bool,
  maxLines: PropTypes.number,
  dataTestId: PropTypes.string
};
export default TableBody;